import { memo } from "react";

import PropTypes from "prop-types";
import classNames from "classnames";
import { ArrowLeftIcon, ArrowRightIcon } from "app/icons/navigation";

const CarouselArrow = ({ orientation, className = "images-carousel" }) => {
	const isLeft = orientation === "left";

	return (
		<div className={classNames(`${className}__arrow`, `${className}__arrow-${orientation}`)}>
			{isLeft ? <ArrowLeftIcon /> : <ArrowRightIcon />}
		</div>
	);
};

CarouselArrow.propTypes = {
	orientation: PropTypes.string,
	className: PropTypes.string,
};

export default memo(CarouselArrow);
